import { render } from "./GoalsEdition.vue?vue&type=template&id=2e3d23dc&scoped=true"
import script from "./GoalsEdition.vue?vue&type=script&lang=js"
export * from "./GoalsEdition.vue?vue&type=script&lang=js"

import "./GoalsEdition.vue?vue&type=style&index=0&id=2e3d23dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3d23dc"]])

export default __exports__